export const EVENT_CHAT_CREATED = 'chat_created'
export const EVENT_CHAT_SHARED = 'chat_shared'
export const EVENT_INTERNET_IMAGE_SEARCH = 'internet_image_search'
export const EVENT_COMMUNITY_TEMPLATE_VIEWED = 'community_template_viewed'
export const EVENT_COMMUNITY_TEMPLATE_USED = 'community_template_used'
